export default (value:any) => value.start && value.end;
